/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import { SpriteIcon } from '@/components/ui/sprite-icon';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export default function CartBadgeIcon({
    numberOfItems,
    iconClassName,
}: {
    numberOfItems: number;
    iconClassName?: string;
}): ReactElement {
    return (
        <>
            <SpriteIcon name="bag" className={cn('size-8', iconClassName)} />
            {numberOfItems > 0 && (
                <Badge
                    variant="default"
                    className="absolute top-0.5 right-0.5 min-w-[18px] h-[18px] rounded-full px-1 text-xs font-medium flex items-center justify-center bg-cart-badge-color border border-white"
                    data-testid="shopping-cart-badge">
                    {numberOfItems}
                </Badge>
            )}
        </>
    );
}
